/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Resource and Data Exchange
 * Private Data Enclave API
 * OpenAPI spec version: 0.1.0
 */
import type {HttpContext, HttpEvent, HttpParams} from '@angular/common/http';
import {HttpResponse as AngularHttpResponse, HttpClient, HttpHeaders} from '@angular/common/http';

import {Injectable, inject} from '@angular/core';

import {Observable} from 'rxjs';

import {APP_ENVIRONMENT} from '@app/core/tokens/app-environment.token';
import {type AppEnvironment} from '@models/environment';

import type {
  DatasetCreate,
  DatasetPatch,
  DatasetPut,
  DatasetResponse,
  DatasetResponseList,
  DeleteDatasetFileParams,
  DeleteDatasetParams,
  DownloadDatasetFileParams,
  DownloadDatasetFileWithPresignedURLParams,
  FileVersionResponse,
  GenerateDatasetFileDownloadLinkParams,
  GetDatasetParams,
  GetDatasetsParams,
  GetPisOnDatasetAssociatedProjectsOverSizeLimit200,
  PresignedUrlResponse,
  RequestBodyFileUpload,
  UploadDatasetFileParams,
} from '../../models';

interface HttpClientOptions {
  readonly headers?: HttpHeaders | Record<string, string | string[]>;
  readonly context?: HttpContext;
  readonly params?: HttpParams | Record<string, string | number | boolean | Array<string | number | boolean>>;
  readonly reportProgress?: boolean;
  readonly withCredentials?: boolean;
  readonly credentials?: RequestCredentials;
  readonly keepalive?: boolean;
  readonly priority?: RequestPriority;
  readonly cache?: RequestCache;
  readonly mode?: RequestMode;
  readonly redirect?: RequestRedirect;
  readonly referrer?: string;
  readonly integrity?: string;
  readonly referrerPolicy?: ReferrerPolicy;
  readonly transferCache?: {includeHeaders?: string[]} | boolean;
  readonly timeout?: number;
}

type HttpClientBodyOptions = HttpClientOptions & {
  readonly observe?: 'body';
};

type HttpClientEventOptions = HttpClientOptions & {
  readonly observe: 'events';
};

type HttpClientResponseOptions = HttpClientOptions & {
  readonly observe: 'response';
};

type HttpClientObserveOptions = HttpClientOptions & {
  readonly observe?: 'body' | 'events' | 'response';
};

type AngularHttpParamValue = string | number | boolean | Array<string | number | boolean>;
type AngularHttpParamValueWithNullable = AngularHttpParamValue | null;

function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys?: ReadonlySet<string>,
  preserveRequiredNullables?: false,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValue>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: true,
  passthroughKeys?: undefined,
): Record<string, AngularHttpParamValueWithNullable>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> | undefined,
  preserveRequiredNullables: boolean | undefined,
  passthroughKeys: ReadonlySet<string>,
): Record<string, unknown>;
function filterParams(
  params: Record<string, unknown>,
  requiredNullableKeys: ReadonlySet<string> = new Set(),
  preserveRequiredNullables = false,
  passthroughKeys: ReadonlySet<string> = new Set(),
): Record<string, unknown> {
  const filteredParams: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(params)) {
    if (passthroughKeys.has(key)) {
      if (value !== undefined) {
        filteredParams[key] = value;
      }
      continue;
    }
    if (Array.isArray(value)) {
      const filtered = value.filter(
        item => item != null && (typeof item === 'string' || typeof item === 'number' || typeof item === 'boolean'),
      ) as Array<string | number | boolean>;
      if (filtered.length) {
        filteredParams[key] = filtered;
      }
    } else if (value === null && requiredNullableKeys.has(key)) {
      // With a paramsSerializer (preserveRequiredNullables) the literal null
      // is passed through for it to consume; without one, emit an empty
      // string so the required key still reaches the wire as `?key=`
      // instead of being silently dropped. See #3712.
      filteredParams[key] = preserveRequiredNullables ? null : '';
    } else if (
      value != null &&
      (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean')
    ) {
      filteredParams[key] = value;
    }
  }
  return filteredParams;
}

@Injectable({providedIn: 'root'})
export class DatasetsService {
  public http = inject(HttpClient);
  _environment: AppEnvironment = inject(APP_ENVIRONMENT);
  _baseUrl: string | undefined = undefined;

  get baseUrl(): string {
    return this._baseUrl ?? this._environment.api;
  }

  set baseUrl(newUrl: string) {
    this._baseUrl = newUrl;
  }

  /**
   * Gets a list of all dataset metadata (matching query params) where
   * requesting user has permissions to view
   * @summary Get Datasets
   */
  getDatasets<TData = DatasetResponseList>(
    params?: GetDatasetsParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getDatasets<TData = DatasetResponseList>(
    params?: GetDatasetsParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getDatasets<TData = DatasetResponseList>(
    params?: GetDatasetsParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getDatasets<TData = DatasetResponseList>(
    params?: GetDatasetsParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Creates a new dataset
   * @summary Create Dataset
   */
  createDataset<TData = unknown | void>(
    datasetCreate: DatasetCreate,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  createDataset<TData = unknown | void>(
    datasetCreate: DatasetCreate,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  createDataset<TData = unknown | void>(
    datasetCreate: DatasetCreate,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  createDataset<TData = unknown | void>(
    datasetCreate: DatasetCreate,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/datasets`, datasetCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/datasets`, datasetCreate, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/datasets`, datasetCreate, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Schedules a specified (dataset_id) dataset where requesting user is an admin on the dataset for permanent
   * deletion. If param: 'immediate' is True, a permanent and immediate delete occurs for the dataset as well as all its
   * associated files.
   * @summary Delete Dataset
   */
  deleteDataset<TData = unknown>(
    datasetId: string,
    params?: DeleteDatasetParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteDataset<TData = unknown>(
    datasetId: string,
    params?: DeleteDatasetParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteDataset<TData = unknown>(
    datasetId: string,
    params?: DeleteDatasetParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteDataset<TData = unknown>(
    datasetId: string,
    params?: DeleteDatasetParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Gets metadata for a specified (dataset_id) dataset where the requesting user has a role.
   *
   * Note: By default, this will trigger a REDCap refresh. To skip the refresh (for example, when
   * loading data for the edit page), pass refresh=false as a query parameter.
   * @summary Get Dataset
   */
  getDataset<TData = DatasetResponse>(
    datasetId: string,
    params?: GetDatasetParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getDataset<TData = DatasetResponse>(
    datasetId: string,
    params?: GetDatasetParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getDataset<TData = DatasetResponse>(
    datasetId: string,
    params?: GetDatasetParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getDataset<TData = DatasetResponse>(
    datasetId: string,
    params?: GetDatasetParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Patches dataset metadata for a specified (dataset_id) dataset
   * where requesting user is an admin on the dataset.
   * @summary Patch Dataset
   */
  patchDataset<TData = unknown | void>(
    datasetId: string,
    datasetPatch: DatasetPatch,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  patchDataset<TData = unknown | void>(
    datasetId: string,
    datasetPatch: DatasetPatch,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  patchDataset<TData = unknown | void>(
    datasetId: string,
    datasetPatch: DatasetPatch,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  patchDataset<TData = unknown | void>(
    datasetId: string,
    datasetPatch: DatasetPatch,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.patch<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.patch<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPatch, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.patch<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPatch, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Updates dataset metadata for a specified (dataset_id) dataset
   * where requesting user is an admin on the dataset.
   * @summary Update Dataset
   */
  updateDataset<TData = unknown | void>(
    datasetId: string,
    datasetPut: DatasetPut,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  updateDataset<TData = unknown | void>(
    datasetId: string,
    datasetPut: DatasetPut,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  updateDataset<TData = unknown | void>(
    datasetId: string,
    datasetPut: DatasetPut,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  updateDataset<TData = unknown | void>(
    datasetId: string,
    datasetPut: DatasetPut,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPut, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}`, datasetPut, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Uploads a file to a specified (dataset_id) dataset.
   * Set param "edit" to True for file editing.
   * @summary Upload Dataset File
   */
  uploadDatasetFile<TData = FileVersionResponse>(
    datasetId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params?: UploadDatasetFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  uploadDatasetFile<TData = FileVersionResponse>(
    datasetId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params?: UploadDatasetFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  uploadDatasetFile<TData = FileVersionResponse>(
    datasetId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params?: UploadDatasetFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  uploadDatasetFile<TData = FileVersionResponse>(
    datasetId: string,
    requestBodyFileUpload: RequestBodyFileUpload,
    params?: UploadDatasetFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const formData = new FormData();
    formData.append(`file`, requestBodyFileUpload.file);

    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.post<TData>(`${this.baseUrl}/datasets/${datasetId}/files`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.post<TData>(`${this.baseUrl}/datasets/${datasetId}/files`, formData, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.post<TData>(`${this.baseUrl}/datasets/${datasetId}/files`, formData, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Schedules a specified dataset file version for permanent deletion. If param: 'immediate' is True, a permanent and
   * immediate delete occurs from the database and file storage for the specified file version
   * @summary Delete Dataset File
   */
  deleteDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    params?: DeleteDatasetFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  deleteDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    params?: DeleteDatasetFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  deleteDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    params?: DeleteDatasetFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  deleteDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    params?: DeleteDatasetFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.delete<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Downloads specified version of data file of a specified (dataset_id)
   * dataset. If "latest" is passed in "version_id", the most recent version of the file in minio is returned.
   * Set param "edit" to True for file editing.
   *
   * When `download_stored_format` is True:
   * - Used mainly when making dataset files public through the frontend to minimize resource/time consumption.
   * - The file is served in the exact format in which it was stored in MinIO.
   * - If the file was stored as the compressed version of file.txt, it is served as the compressed version.
   * - If the file was stored as file.txt (e.g., when uploaded via API with `compressed` set to False),
   *   it is served as file.txt.
   *
   * When `harmonize_dates` is `True`:
   * - Automatically detected CSV date columns are harmonized to ISO 8601 UTC format during streaming.
   * @summary Download Dataset File
   */
  downloadDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: DownloadDatasetFileParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  downloadDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: DownloadDatasetFileParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  downloadDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: DownloadDatasetFileParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  downloadDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: DownloadDatasetFileParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Uses pre-signed url to download dataset file. Otherwise, functionality is identical to the regular download
   * dataset file endpoint
   * @summary Download Dataset File With Presigned Url
   */
  downloadDatasetFileWithPresignedURL<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params: DownloadDatasetFileWithPresignedURLParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  downloadDatasetFileWithPresignedURL<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params: DownloadDatasetFileWithPresignedURLParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  downloadDatasetFileWithPresignedURL<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params: DownloadDatasetFileWithPresignedURLParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  downloadDatasetFileWithPresignedURL<TData = unknown>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params: DownloadDatasetFileWithPresignedURLParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/download-presigned`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/download-presigned`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/download-presigned`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Generates a pre-signed URL for downloading a dataset file.
   *
   * This endpoint returns a pre-signed URL that allows access to the file stored in MinIO. In addition, it
   * provides the size of the MinIO object (`stored_file_size`), which may differ from the original file size due
   * to compression. The `stored_file_size` represents the size of the object stored in MinIO,
   * whereas the `file_size` denotes the original size of the file as intended by the user during the upload.
   *
   * Notes:
   * - When publishing dataset files, ensure `download_stored_format` is set to true. Use the `stored_file_size`
   *   to determine the number of chunks for uploading to `resource_explorer_service`.
   * - Keeping files compressed optimizes upload time to S3 and Libradata. Compressed files are downloaded,
   *   decompressed, and then transferred to public storage, enhancing efficiency. This process involves:
   *     1. Downloading the compressed file to the user’s browser from `data_enclave_service`.
   *     2. Sending the compressed file to `resource_explorer_service` using the front end code, which then decompresses it
   *        and uploads it to public storage.
   * - The interaction between `resource_explorer_service` and `data_enclave_service` is constrained by firewall rules,
   *   making the front-end code the intermediary.
   * @summary Generate Dataset File Download Link
   */
  generateDatasetFileDownloadLink<TData = PresignedUrlResponse>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: GenerateDatasetFileDownloadLinkParams,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  generateDatasetFileDownloadLink<TData = PresignedUrlResponse>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: GenerateDatasetFileDownloadLinkParams,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  generateDatasetFileDownloadLink<TData = PresignedUrlResponse>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: GenerateDatasetFileDownloadLinkParams,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  generateDatasetFileDownloadLink<TData = PresignedUrlResponse>(
    datasetId: string,
    fileVersionId: string | 'latest',
    params?: GenerateDatasetFileDownloadLinkParams,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    const filteredParams = filterParams({...params, ...options?.params}, new Set<string>([]));

    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/get-presigned-url`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
        params: filteredParams,
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/get-presigned-url`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
        params: filteredParams,
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/get-presigned-url`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
      params: filteredParams,
    });
  }
  /**
   * Restores a document that was previously deleted from a specified (project_id) project
   * @summary Restore Dataset File
   */
  restoreDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  restoreDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  restoreDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  restoreDatasetFile<TData = unknown>(
    datasetId: string,
    fileVersionId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/files/${fileVersionId}/restore`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Server-sent event: Returns scan completion status for a given dataset file version
   * @summary Is Scan Complete
   */
  isScanComplete<TData = void>(
    datasetId: string,
    fileVersionId: string | 'latest',
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  isScanComplete<TData = void>(
    datasetId: string,
    fileVersionId: string | 'latest',
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  isScanComplete<TData = void>(
    datasetId: string,
    fileVersionId: string | 'latest',
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  isScanComplete<TData = void>(
    datasetId: string,
    fileVersionId: string | 'latest',
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/is-scan-complete/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/is-scan-complete/${fileVersionId}`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/is-scan-complete/${fileVersionId}`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Gets a list of pi's associated with the dataset's primary project that are over the file size limit
   * @summary Get Pis On Dataset Associated Projects Over Size Limit
   */
  getPisOnDatasetAssociatedProjectsOverSizeLimit<TData = GetPisOnDatasetAssociatedProjectsOverSizeLimit200>(
    datasetId: string,
    options?: HttpClientBodyOptions,
  ): Observable<TData>;
  getPisOnDatasetAssociatedProjectsOverSizeLimit<TData = GetPisOnDatasetAssociatedProjectsOverSizeLimit200>(
    datasetId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getPisOnDatasetAssociatedProjectsOverSizeLimit<TData = GetPisOnDatasetAssociatedProjectsOverSizeLimit200>(
    datasetId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getPisOnDatasetAssociatedProjectsOverSizeLimit<TData = GetPisOnDatasetAssociatedProjectsOverSizeLimit200>(
    datasetId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/pi-size-limit`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/pi-size-limit`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/pi-size-limit`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * Returns whether a dataset currently meets the requirements to be made public, along with details about any unmet
   * public dataset requirements.
   * @summary Get Dataset Public Readiness
   */
  getDatasetPublicReadiness<TData = unknown>(datasetId: string, options?: HttpClientBodyOptions): Observable<TData>;
  getDatasetPublicReadiness<TData = unknown>(
    datasetId: string,
    options?: HttpClientEventOptions,
  ): Observable<HttpEvent<TData>>;
  getDatasetPublicReadiness<TData = unknown>(
    datasetId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  getDatasetPublicReadiness<TData = unknown>(
    datasetId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/public-readiness`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/public-readiness`, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.get<TData>(`${this.baseUrl}/datasets/${datasetId}/public-readiness`, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
  /**
   * If a dataset is scheduled to be deleted, this endpoint will remove it from the schedule
   * @summary Restore Dataset
   */
  restoreDataset<TData = unknown>(datasetId: string, options?: HttpClientBodyOptions): Observable<TData>;
  restoreDataset<TData = unknown>(datasetId: string, options?: HttpClientEventOptions): Observable<HttpEvent<TData>>;
  restoreDataset<TData = unknown>(
    datasetId: string,
    options?: HttpClientResponseOptions,
  ): Observable<AngularHttpResponse<TData>>;
  restoreDataset<TData = unknown>(
    datasetId: string,
    options?: HttpClientObserveOptions,
  ): Observable<TData | HttpEvent<TData> | AngularHttpResponse<TData>> {
    if (options?.observe === 'events') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'events',
      });
    }

    if (options?.observe === 'response') {
      return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/restore`, undefined, {
        ...(options as Omit<NonNullable<typeof options>, 'observe'>),
        observe: 'response',
      });
    }

    return this.http.put<TData>(`${this.baseUrl}/datasets/${datasetId}/restore`, undefined, {
      ...(options as Omit<NonNullable<typeof options>, 'observe'>),
      observe: 'body',
    });
  }
}

export type GetDatasetsClientResult = NonNullable<DatasetResponseList>;
export type CreateDatasetClientResult = NonNullable<unknown | void>;
export type DeleteDatasetClientResult = NonNullable<unknown>;
export type GetDatasetClientResult = NonNullable<DatasetResponse>;
export type PatchDatasetClientResult = NonNullable<unknown | void>;
export type UpdateDatasetClientResult = NonNullable<unknown | void>;
export type UploadDatasetFileClientResult = NonNullable<FileVersionResponse>;
export type DeleteDatasetFileClientResult = NonNullable<unknown>;
export type DownloadDatasetFileClientResult = NonNullable<unknown>;
export type DownloadDatasetFileWithPresignedURLClientResult = NonNullable<unknown>;
export type GenerateDatasetFileDownloadLinkClientResult = NonNullable<PresignedUrlResponse>;
export type RestoreDatasetFileClientResult = NonNullable<unknown>;
export type IsScanCompleteClientResult = NonNullable<void>;
export type GetPisOnDatasetAssociatedProjectsOverSizeLimitClientResult =
  NonNullable<GetPisOnDatasetAssociatedProjectsOverSizeLimit200>;
export type GetDatasetPublicReadinessClientResult = NonNullable<unknown>;
export type RestoreDatasetClientResult = NonNullable<unknown>;
